// extracted by mini-css-extract-plugin
export default {"submitBtn":"submitButton_submitBtn__IvT93"};